<div class="p-field">
  <label kodit-form-label [for]="fieldLabelFor"
    >{{ fieldLabel }}{{ isFieldRequired ? ' *' : '' }}</label
  >
  <ng-content></ng-content>
</div>
